import { createApiClient } from '@manuia/contracts';
import { getAccessToken } from '../auth/keycloak';

/** Client typé : même origine, jeton Keycloak injecté à chaque appel. */
export const api = createApiClient({ baseUrl: '', getAccessToken });

export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
    readonly details?: Array<{ path: string; message: string }>,
  ) {
    super(message);
  }
}

/** Convertit la paire { data, error } d'openapi-fetch en valeur ou exception typée. */
export function unwrap<T>(result: { data?: T; error?: unknown; response: Response }): T {
  if (result.error !== undefined || result.data === undefined) {
    const err = (result.error ?? {}) as { message?: string; errors?: Array<{ path: string; message: string }> };
    throw new ApiError(result.response.status, err.message ?? `Erreur ${result.response.status}`, err.errors);
  }
  return result.data;
}

/** Téléchargement authentifié d'un binaire (PDF) : fetch avec jeton, puis ouverture dans un onglet. */
export async function openAuthenticatedFile(path: string): Promise<void> {
  const token = await getAccessToken();
  const response = await fetch(path, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!response.ok) throw new ApiError(response.status, `Document indisponible (${response.status})`);
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank', 'noopener');
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
